<template>
  <div :class="{ 'json-builder-sms-compliance': isSmsCompliance }">
  <div v-if="allElements.length" :class="['model-sections width100P', { 'carousel-section': isCarouselPresent ,'uploadURLContainer': shouldApplyURLUploadClass }]">
    <div lines="none" v-for="(thisElement, eIndex) in allElements" :key="eIndex" class="table-reorder ion-no-padding">
      <!-- text -->
      <div v-if="thisElement.type === 'text'">
        <div class="bodyContainer">
          <RichTextBoxV2
            ref="TextRichTextBox"
            :value="thisElement.payload"
            :showSmiley="true"
            :showCustomFiledInsertion="true"
            :maxLength="channelLimitConfig.text"
            :readonly="isViewOnlyMode"
            :showRemainingText="true"
            :showBotVariable="false"
            @input="(prop) => onInputRichTextBox(thisElement, prop)"
            :placeholder="editorOption.placeholder || 'Type a message'"
            :style="{ width: isSmsCompliance ? '100%' : '450px' }"
          />
          <!-- SMS Transcode Bttn -->
          <div v-if="isSmsSelected && !disableTranscode" class="transcodeContainer">
            <div class="flex-start flexText alignCenter">
              <VButton @click="getSmsTranscodedMessage(thisElement.payload, eIndex)" class="vvd-btn-secondary" connotation="cta" appearance="outlined" label="Transcode" icon="toggle-line" :disabled="thisElement.payload == undefined || isTranscodeEnabledForSms(thisElement.payload) || isViewOnlyMode || commonLoader" :pending="commonLoader" />
              <HelpTooltip>Use transcoding when your SMS contains characters (such as emojis, special symbols, or non-Latin languages) that may not be supported by all devices or networks. Transcoding helps ensure message delivery and can reduce costs by converting the message to a compatible, lower-cost format like GSM-7.</HelpTooltip>
            </div>
          </div>

        <div v-if="thisElement.buttons && thisElement.buttons.length">
          <div v-for="(thisButton, bIndex) in thisElement.buttons" :key="'element' + eIndex + 'button' + bIndex" @click="onclickButton('text', bIndex, eIndex)" class="bttnContainer cursorPointer" :class="{  'activeButton' : bIndex == buttonIndex, 'lastButton' : bIndex == 2, 'disabled': isViewOnlyMode}" :style="{ justifyContent: 'center' }">
            <div class="button-text-container">
              <span class="bttnTitle ion-no-margin">{{ thisButton.text }}</span>
            </div>
          </div>
        </div>
        <div v-if="showAddNewBttn"> 
          <VButton v-if="thisElement.buttons && thisElement.buttons.length < channelLimitConfig.buttonLimit && isSmsNotSelected" @click="addEmptyButton(thisElement)" :disabled="isViewOnlyMode" class="vvd-btn-secondary templateAddButton" connotation="cta" appearance="outlined" :label="'Add New (' + (channelLimitConfig.buttonLimit - thisElement.buttons.length) + ' left)'" icon="plus-line" />
        </div>
        </div>
      </div>
      <div class="pasteUrlMargin flexBox" v-if="thisElement.type === 'image'"> 
        <upload-files-v-2 uploadURLEnabled allowDynamicURL
        :isViewOnlyMode="isViewOnlyMode"
        :allowedImageTypes="supportedImageTypes.formats"
        :media_url="media_url"
        :uploaded_url_type="uploaded_url_type"
        @url-uploaded="(uploadedUrlData) => handleUrlUpload(uploadedUrlData.file_url, eIndex)"
        :meta="{is_export: false, is_broadcast: false, is_redact: false, is_public: true, conversation_id: undefined, channel: selectedChannel}"
        type="image" :multiple="false" id="'headerImage'" ref="headerImage" :maxFileSizeAllowed="channelLimitConfig.image" v-model:loading="filesUploading" @send-upload-data="handleFilesUpload" @url-type-changed="(value) => { isStaticorDynamic = value; }">
          <div class="pasteUrlMargin flexBox">
            <div class="info-box">
              <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
              <p class="title ion-no-margin">
                {{ 'Max file size ' + channelLimitConfig.image }} {{ 'MB' }} {{ supportedImageTypes.message }}
              </p>
            </div>
            <VButton @click="uploadNewFiles(eIndex)" :disabled="filesUploading || isViewOnlyMode" class="vvd-btn-secondary custom_mrg_bottom width100P" connotation="cta" appearance="outlined" label="Upload Image" icon="image-line" :pending="filesUploading" />
          </div>
        </upload-files-v-2>
      </div>
      <div class="pasteUrlMargin flexBox" v-if="thisElement.type === 'video'"> 
        <upload-files-v-2 uploadURLEnabled allowDynamicURL
        :isViewOnlyMode="isViewOnlyMode"
        :allowedVideoTypes="supportedVideoFiles.formats"
        :media_url="media_url"
        :uploaded_url_type="uploaded_url_type"
        @url-uploaded="(uploadedUrlData) => handleUrlUpload(uploadedUrlData.file_url, eIndex)"
        :meta="{is_export: false, is_broadcast: false, is_redact: false, is_public: true, conversation_id: undefined, channel: selectedChannel}"
         type="video" :multiple="false" id="'headerVideo'" ref="headerVideo" :maxFileSizeAllowed="channelLimitConfig.video" v-model:loading="filesUploading" @send-upload-data="handleFilesUpload" @url-type-changed="(value) => { isStaticorDynamic = value; }">
          <div class="pasteUrlMargin flexBox">
            <div class="info-box">
              <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
              <p class="title ion-no-margin">
                {{ 'Max file size ' + channelLimitConfig.video }} {{ 'MB' }} {{ supportedVideoFiles.message }}
              </p>
            </div>
            <VButton @click="uploadNewFiles(eIndex)" :disabled="filesUploading || isViewOnlyMode" class="vvd-btn-secondary custom_mrg_bottom width100P" connotation="cta" appearance="outlined" label="Upload Video" icon="video-line" :pending="filesUploading" />
          </div>
        </upload-files-v-2>
      </div>
      <div class="pasteUrlMargin flexBox" v-if="thisElement.type === 'document'">
        <upload-files-v-2 uploadURLEnabled allowDynamicURL
        :isViewOnlyMode="isViewOnlyMode"
          :allowedDocumentTypes="supportedFiles.formats"
          :media_url="media_url"
          :uploaded_url_type="uploaded_url_type"
          @url-uploaded="(uploadedUrlData) => handleUrlUpload(uploadedUrlData.file_url, eIndex)"
          :meta="{is_export: false, is_broadcast: false, is_redact: false, is_public: true, conversation_id: undefined, channel: selectedChannel}"
        type="document" :multiple="false" id="'headerDocument'" ref="headerDocument" :maxFileSizeAllowed="channelLimitConfig.document" v-model:loading="filesUploading" @send-upload-data="handleFilesUpload" @url-type-changed="(value) => { isStaticorDynamic = value; }">
          <div class="pasteUrlMargin flexBox">
            <div class="info-box">
              <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
              <p class="title ion-no-margin">
                {{ 'Max file size ' + channelLimitConfig.document }} {{ 'MB' }} {{ supportedFiles.message }}
              </p>
            </div>
            <VButton @click="uploadNewFiles(eIndex)" :disabled="filesUploading || isViewOnlyMode" class="vvd-btn-secondary custom_mrg_bottom width100P" connotation="cta" appearance="outlined" label="Upload Document" icon="clear-file-line" :pending="filesUploading" />
          </div>
        </upload-files-v-2>
      </div>
      <!-- reply -->
      <div v-if="thisElement.type === 'reply'" class="element-container">
        <RichTextBoxV2
          ref="ReplyRichTextBox"
          :value="thisElement.payload"
          :showSmiley="true"
          :showCustomFiledInsertion="true"
          :maxLength="channelLimitConfig.text"
          :readonly="isViewOnlyMode"
          :showRemainingText="true"
          :showBotVariable="false"
          @input="(prop) => thisElement.payload = prop"
          placeholder="Enter a Reply"
          :style="{ width: '450px' }"
        />
        <div class="quick-reply-button-container">
          <div v-if="thisElement.buttons && thisElement.buttons.length" class="quick-reply-buttons-wrapper" :class="{ complete: thisElement.buttons.length == 3 }">
            <div class="text-button-wrapper" v-for="(thisButton, bIndex) in thisElement.buttons" :key="'element' + eIndex + 'button' + bIndex">
              <button class="btn-template-dynamic-action" @click="onclickButton('reply', bIndex, eIndex)" :class="{ 'activeReplyButton': bIndex == buttonIndex, 'disabled': isViewOnlyMode }">
                <template v-if="thisButton.type !== undefined">
                  <img v-if="getIconForButton(thisButton).includes('/')" :src="getIconForButton(thisButton)" class="btn-icon-img" :class="{ 'active_icon': bIndex == buttonIndex }" alt="" />
                  <VIcon v-else :name="getIconForButton(thisButton)" class="txt_clr_primary paddingRight10P" :class="{ 'active_icon': bIndex == buttonIndex }"></VIcon>
                </template>
                <span class="replyBttnTitle">{{ thisButton.text }}</span>
              </button>
              <div class="text-buttons"><VIcon name="close-line" :class="{ 'closeIcon': bIndex == buttonIndex, 'disabled': isViewOnlyMode}" @click="removeQuickReplyButtonHandler(bIndex, eIndex)"></VIcon></div>
            </div>
          </div>
          <div class="text-button-wrapper" :class="{'disabled' : isViewOnlyMode}" v-if="thisElement.buttons && thisElement.buttons.length < channelLimitConfig.quickReplyButtonLimit">
            <button class="btn-template-dynamic-action" @click="() => thisElement.buttons.push({ text: selectedChannel === 'googlercs' ? 'Suggestion' : 'Button', payload: undefined })">
              + Add New
            </button>
          </div>
        </div>
      </div>
      <!-- Delete Bttn -->
      <span v-if="isSmsNotSelected" class="tooltip_container delete-field"  :class="isGooglercsSelected ? (thisElement.type === 'carousel' ? 'rcsCarouselDeleteBttn' : thisElement.type === 'richcard' ? 'rcsRichCardDeleteBttn' : '') : ''">
        <VButton @click="removeContent" class="vvd-btn-danger-outline trashOutline" connotation="alert" appearance="outlined" icon="delete-line" :disabled="isViewOnlyMode" />
        <span class="tooltip_text left" style="width: 80px">Delete</span>
      </span>
      <!-- Show Document file -->
      <span v-if="thisElement.type === 'document' && thisElement.payload && thisElement.payload.length && !filesUploading && isStaticorDynamic == 'static'" class="tooltip_container info-field"> 
        <VButton @click="openLink(thisElement.payload)" class="vvd-btn-secondary openDocumentIcon" connotation="cta" appearance="outlined" icon="info-line" />
        <span class="tooltip_text left" style="width: 100px">View Uploaded Document</span>
      </span>
      <!-- Carousel or RichCard -->
      <div v-if="thisElement.type === 'carousel' || thisElement.type === 'richcard'">
        <div v-if="selectedChannel === 'googlercs'" class="info-box marginBottom justify-content">
          <div class="flex-start alignCenter"> 
            <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
            <ul class="info-text ion-no-margin">
              <li class="title">Title and description are required, media and buttons are optional</li>
              <li class="title">Max file size 100MB per media </li>
              <li class="title">Supported media formats - Image (jpeg/jpg, gif, png) Video (m4v, mp4, mpeg, mpeg-4, webm) </li>
            </ul>
          </div>
          <div class="text-right">
            <VButton class="vvd-btn-secondary" connotation="cta" appearance="outlined" label="Learn More" @click="learnMore" />
          </div>
        </div>
        <CarouselTemplate ref="CarouselComponent" :carousel_type="thisElement.type" :carouselData="carousel_message_json" @finalCarouselData="finalCarouselData" :isbroadcastCarousel="true" :broadcastCarouselSize="100" :isViewOnlyMode="isViewOnlyMode" enableURLUpload :showBotVariable="false"/>
      </div>
    </div>
  </div>
  <Teleport to="body">
    <div v-if="isPopperOpen" class="jb-popper-backdrop" @click="closePopper"></div>
    <div v-if="isPopperOpen" class="jb-popper-container">
      <popper :is_agent_or_group_req="true" :channel="selectedChannel" :showSuggestionReplies="showSuggestionReplies" :deleteButton="showDeleteBttn" :type="addEditModal" :config="popperConfig" @submit="popperSubmit" @closePopper="closePopper" @deleteBttn="removeButtonHandler"/>
    </div>
  </Teleport>
  <!-- Insert Parameter Dialog -->
  <VDialog :open="insertParamIndex !== -1" modal @close="insertParamIndex = -1" headline="Insert Parameter" style="--dialog-min-inline-size: 400px;">
    <template #body>
      <div class="action-sheet-list">
        <div v-for="(option, oIndex) in paramsOptions" :key="oIndex" class="action-sheet-item" @click="() => { option.handler(); insertParamIndex = -1; }">
          {{ option.text }}
        </div>
      </div>
    </template>
  </VDialog>
  <!-- Add Custom Field Dialog -->
  <VDialog
    v-if="addCustomFieldIndex !== -1"
    :open="addCustomFieldIndex !== -1"
    modal
    @close="addCustomFieldIndex = -1"
    headline="Add Custom Field"
    style="--dialog-min-inline-size: 400px;"
  >
    <template #body>
      <div class="gridMargin">
        <p class="sub-title">Custom Field</p>
        <VTextField v-model="customFieldText" placeholder="Enter custom field value" aria-label="custom field" appearance="ghost" class="vivid-input"></VTextField>
      </div>
    </template>
    <template #action-items>
      <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Done" :disabled="customFieldText == '' || customFieldText == undefined" @click="confirmAddCustomField" />
    </template>
  </VDialog>
  </div>
</template>

<script>
import popper from '@/components/popper';
import messageTags from '@/resources/data/message-tags.json';
import CarouselTemplate from "@/components/whatsapp-templates/carousel-component";
import suggestionChips from "@/components/suggestion-chips";
import { getIcon } from '@/helpers/icon.helper';
import uploadFilesV2 from '@/components/uploadFilesV2.vue';
import apiInterceptor from '@/shared/apiInterceptor';
import HelpTooltip from "@/components/HelpTooltip.vue";
import RichTextBoxV2 from '@/components/rich-text-box-v2.vue';
import { useUIStore } from '@/stores/ui';
import { environment } from '@/shared/env.js';
import { isTranscodeEnabledForSms } from '@/helpers/sms.helper.js';

export default {
  mixins: [],
  components: {popper, CarouselTemplate, suggestionChips, uploadFilesV2, HelpTooltip, RichTextBoxV2 },
  data() {
    return {
      loading: false,
      loadingProducts: false,
      allElements: [],
      editIndex: -1,
      buttonIndex: -1,
      addEditModal: undefined,
      deleteAllMode: false,
      insertParamIndex: -1,
      paramsOptions: [
        {
          text: "User's First Name",
          handler: () => {
						this.setTextToCurrentPos("<username>");
          }
        },
        {
          text: 'Store Name',
          handler: () => {
						this.setTextToCurrentPos("<shopname>");
          }
        },
        {
          text: 'Agent Name',
          handler: () => {
						this.setTextToCurrentPos("<agentname>");
          }
        },
        {
          text: 'Account Owner Name',
          handler: () => {
						this.setTextToCurrentPos("<sellername>");
          }
        },
        {
          text: 'Support E-mail',
          handler: () => {
						this.setTextToCurrentPos("<selleremail>");
          }
        },
        {
          text: 'Support Phone',
          handler: () => {
						this.setTextToCurrentPos("<sellerphone>");
          }
        },
        {
          text: 'Outlet Address',
          handler: () => {
						this.setTextToCurrentPos("<menuaddress>");
          }
        },
        {
          text: 'Custom Field',
          handler: () => this.addCustomFieldIndex = this.insertParamIndex
				}
			],
			addCustomFieldIndex: -1,
      customFieldText: undefined,
      filesUploading: false,
      uploadfileIndex: -1,
      commonLoader: false,
      editorOption: {
        placeholder: 'Type a message',
      },
      simpleMessageTags: [],
      showDeleteBttn: true,
      carousel_message_json: {
				BODY: {
						title: "Title",
            subtitle: "Subtitle"
				},
				CAROUSEL: {
						cards: []
				}
			},
      mimeTypes: { pdf: "application/pdf", jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png", gif: "image/gif", txt: "text/plain", json: "application/json" },
      showSuggestionReplies: false,
      isStaticorDynamic: 'static',
      media_url: '',
    }
  },
  props: {
    editBroadcast: {
      type: Object
    },
    type: {
      type: String
    },
    removeButton: {
      type: Boolean,
      default: false
    },
    cancelButton: {
      type: Boolean,
      default: false
    },
    isViewOnlyMode: {
      type: Boolean,
      default: false
    },
    uploaded_url_type: {
      type: String,
      default: 'static'
    },
    disableTranscode: {
      type: Boolean,
      default: false
    },
    isSmsCompliance: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // Generate message json elements for both EDIT and DUPLICATE broadcast cases
    if (this.editBroadcast.id || this.editBroadcast.page_id?.trim()) {
      this.generateAdMessageJsonElements();
    }
    this.setMessageTags();
  },
  emits: ['finalJson', 'finalJsonElements', 'loading', 'removeContent', 'finalCarouselData', 'url-type'],
  computed: {
    supportedImageTypes() {
      if(this.selectedChannel === 'googlercs') {
        return {
          formats: 'image/png, image/jpeg, image/jpg, image/gif',
          message: '(.jpg, .png, or .gif only)'
        }
      } else {
        return {
          formats: 'image/png, image/jpeg, image/jpg',
          message: '(.jpg, or .png only)'
        }
      } 
    },
    supportedFiles() {
      if(this.selectedChannel === 'googlercs') {
        return {
          formats: 'application/pdf',
          message: '(.pdf only)'
        }
      } else {
        return {
          formats: 'application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf',
          message: '(.pdf, .doc, .xls or .txt only)'
        }
      } 
    },
    supportedVideoFiles() {
      if(this.selectedChannel === 'googlercs') {
        return {
          formats: 'video/mp4, video/mpeg, video/mpeg4, video/m4v, video/webm',
          message: '(.mp4, .mpeg, .mpeg4, .m4v, or .webm only)'
        }
      } else {
        return {
          formats: 'video/mp4',
          message: '(.mp4 only)'
        }
      } 
    },
    selectedChannel() {
      return this.editBroadcast.channel;
    },
    isSmsNotSelected() {
      return this.selectedChannel !== 'sms';
    },
    isGooglercsSelected() {
      return this.selectedChannel === 'googlercs';
    },
    channelLimitConfig() {
      const defaultLimit = {
        text: 1000,
        image: 4,
        video: 25,
        document: 25,
        quickReplyButtonLimit: 3,
        buttonLimit: 3
      };

      const channel = this.editBroadcast.channel;

      const limits = {
        whatsapp: { text: 1000, image: 4, video: 10, document: 10, quickReplyButtonLimit: 3, buttonLimit: 3 },
        line: { text: 1000, image: 4, video: 25, document: 25, quickReplyButtonLimit: 12, buttonLimit: 3 },
        googlercs: { text: 3000, image: 100, video: 100, document: 100, quickReplyButtonLimit: 11, buttonLimit: 3 },
        sms: { text: 1000, image: 4, video: 25, document: 25, quickReplyButtonLimit: 3, buttonLimit: 3 },
      };

      return limits[channel] || defaultLimit;
    },
    isPopperOpen() {
      return this.addEditModal === 'simple' || this.addEditModal === 'detailed';
    },
    popperConfig() {
      if (this.editIndex > -1 && this.buttonIndex > -1) {
        const button = this.allElements[this.editIndex].buttons[this.buttonIndex];
        return {
          text: button.text,
          action: button.action,
          payload: button.payload || button.url,
          type: button?.type,
          extrainfo: button?.extrainfo,
          url_type: button?.url_type,
          postback_action_type: button?.postback_action_type,
          postback_action: button?.postback_action
        };
      }
      return {};
    },
    showAddNewBttn() {
      const restrictedChannels = ['googlercs', 'sms'];
      return !restrictedChannels.includes(this.editBroadcast.channel);
    },
    isCarouselPresent() {
      return this.allElements.some(thisElement => thisElement.type === 'carousel');
    },
    shouldApplyURLUploadClass() {
      const restrictedChannels = ['googlercs'];
      const isChannelAllowed = restrictedChannels.includes(this.editBroadcast.channel) && (!this.allElements.some(thisElement => thisElement.type === 'carousel') && !this.allElements.some(thisElement => thisElement.type === 'richcard'));
      return isChannelAllowed;
    },
    isSmsSelected() {
      return this.selectedChannel === 'sms';
    },
    allowedVideoTypes() {
      if(this.selectedChannel === 'googlercs') {
        return 'video/mp4, video/mpeg, video/m4v, video/mpeg4, video/webm'
      } else {
        return 'video/mp4, video/mpeg4'
      } 
    }
  },
  watch: {
    allElements: {
      handler: function (allElements) {
        this.$emit('finalJsonElements', { finalJsonElements: allElements });
      },
      deep: true,
      immediate: true,
    },
    carousel_message_json: {
      handler: function () {
        const transformedData = this.transformCarouselData();
        this.$emit('finalCarouselData', { finalCarouselData: transformedData })
      },
      deep: true,
      immediate: true
    },
    isStaticorDynamic(newVal) {
      this.$emit('url-type', newVal);
    },
  },
  methods: {
    isTranscodeEnabledForSms,
    onInputRichTextBox(thisElement, prop) {
      // Normalize newlines to prevent extra line breaks
      let normalizedText = prop;
      if (typeof normalizedText === 'string') {
        // Convert <br> tags to newlines and normalize multiple consecutive newlines
        normalizedText = normalizedText
          .replace(/<br\s*\/?>/gi, '\n')  // Convert <br> tags to newlines
          .replace(/\n{3,}/g, '\n\n')     // Replace 3+ consecutive newlines with 2
          .replace(/^\n+/, '')            // Remove leading newlines
          .replace(/\n+$/, '');           // Remove trailing newlines
      }
      thisElement.payload = normalizedText;
    },
    addEmptyButton(thisElement) {
      thisElement.buttons.push({ text: this.selectedChannel === 'googlercs' ? 'Suggestion' : 'Button', url: "", type: "postback" })
    },
    removeContent() {
      this.allElements = [];
      this.resetCarouselData(true);
      this.$emit('removeContent');
    },
    closePopper() {
      this.addEditModal = '';
      this.editIndex = -1;
      this.buttonIndex = -1;
    },
    onclickButton(type, bIndex, eIndex) {
      if (this.addEditModal != '') {
        this.closePopper()
        setTimeout(() => {
        this.addEditModal = 'detailed';
        }, 500)
      } else {
        this.addEditModal = 'detailed';
      }
      this.showDeleteBttn = true;
      this.editIndex = eIndex;
      this.buttonIndex = bIndex;
    },
    // on edit or view broadcast build elements
    generateAdMessageJsonElements() {
      this.allElements = [];
      const initialFunction = this.editBroadcast;
      initialFunction?.answers?.forEach((answer) => {
        const { type, message, template, id } = answer;
        let field;
        if (type.includes("normalchat")) {
          field = { type: "text", payload: message || '' }
        }

        if (type.includes('buttonreply')) {
          field = { type: "text", payload: message || '' }
          if (template?.buttons?.length) {
            let buttons = [];
            template.buttons.forEach((button) => {
              if (button.type == 'webview') {
                buttons.push({
                  url: button.url,
                  text: button.title,
                  url_type: button?.url_type || '',
                  postback_action_type: button?.postback_action_type,
                  postback_action: button?.postback_action
                });  
              } else if (button.type == 'postback') {
                buttons.push({
                  payload: button.payload,
                  text: button.title,
                  postback_action_type: button?.postback_action_type,
                  postback_action: button?.postback_action
                });
              }
            });
            field.buttons = buttons;
          }
        }

        if (type.includes('cancelled')) {
          this.media_url = message;
          field = { type: "image", payload: message || '' }
        }

        if (type.includes('videoreply')) {
          this.media_url = message;
          field = { type: "video", payload: message || '' }
        }
        if (type.includes('document')) {
          this.media_url = message;
          field = { type: "document", payload: message || '' }
        }
        if (type.includes('quickreplies')) {
          field = { type: "reply", payload: message || '' }
          if (template?.buttons?.length) {
            let buttons = [];
            template.buttons.forEach((button) => {
              buttons.push({
                payload: button.payload,
                text: button.title,
                type: button?.type,
                extrainfo: button?.extrainfo,
                url: button?.url,
                url_type: button?.url_type || '',
                postback_action_type: button?.postback_action_type,
                postback_action: button?.postback_action
              });
            });
            field.buttons = buttons;
          }
        }

        if (type.includes('carousel') && (this.editBroadcast.channel !== 'googlercs')) {
          const details = template.elements;
          let fieldType = undefined;
          let payload = "";
          if (details.image_url) {
            fieldType = "customCard";
            payload = details.image_url;
          }
          field = {
            type: fieldType,
            payload,
            title: details.title,
            subtitle: details.subtitle
          }

          if (details?.buttons?.length) {
            let buttons = [];
            details.buttons.forEach((button) => {
              if (button.type == 'webview') {
                buttons.push({
                  url: button.url,
                  text: button.title,
                  postback_action_type: button?.postback_action_type,
                  postback_action: button?.postback_action
                });
              } else if (button.type == 'postback') {
                buttons.push({
                  payload: button.payload,
                  text: button.title,
                  postback_action_type: button?.postback_action_type,
                  postback_action: button?.postback_action
                });
              }
            });
            field.buttons = buttons;
          }
        }
        if (type.includes('carousel') && (this.editBroadcast.channel === 'googlercs')) {
          const details = template.elements;
          const suggestion_chips = template?.buttons || [];
          // Initialize the carousel structure
          const formattedCarousel = {
            CAROUSEL:{
              cards: [],
              buttons: []
            }
          };
          details.forEach((element) => {
            // Extract buttons and format them
            const buttons = element.buttons.map((button) => {
              if (button.type === 'webview') {
                return {
                  text: button.title,
                  type: 'website',
                  url: button.url,
                  payload: button.url,
                  url_type: button?.url_type || '',
                  postback_action_type: button?.postback_action_type,
                  postback_action: button?.postback_action
                };
              } else if (button.type === 'app_webview') {
                return {
                  text: button.title,
                  type: 'app_webview',
                  url: button.url,
                  payload: button.url,
                  url_type: button?.url_type || '',
                  extrainfo: button.extrainfo,
                  postback_action_type: button?.postback_action_type,
                  postback_action: button?.postback_action
                };
              } else if (button.type === 'phone_number') {
                return {
                  text: button.title,
                  type: 'phone_number',
                  payload: button.payload,
                  postback_action_type: button?.postback_action_type,
                  postback_action: button?.postback_action
                };
              } else if (button.type === 'location') {
                return {
                  text: button.title,
                  type: 'location',
                  payload: button.payload,
                  extrainfo: button.extrainfo,
                  postback_action_type: button?.postback_action_type,
                  postback_action: button?.postback_action
                };
              } else if (button.type === 'calendar') {
                return {
                  text: button.title,
                  type: 'calendar',
                  payload: button.payload,
                  extrainfo: button.extrainfo,
                  postback_action_type: button?.postback_action_type,
                  postback_action: button?.postback_action
                };
              } else if (button.type === 'share') {
                return {
                  text: button.title,
                  type: 'share',
                  payload: button.payload,
                  postback_action_type: button?.postback_action_type,
                  postback_action: button?.postback_action
                };
              } 
              else if (button.type === 'postback') {
                return {
                  text: button.title,
                  type: 'QUICK_REPLY',
                  payload: button.payload,
                  postback_action_type: button?.postback_action_type,
                  postback_action: button?.postback_action
                };
              }
            });

            // Helper function to detect if URL is dynamic (contains variables)
            const isDynamicURL = (url) => {
              if (!url) return false;
              // Check for <variable> or {{variable}} patterns
              return /<[^>]+>/.test(url) || /\{\{[^}]+\}\}/.test(url);
            };

            const imageUrl = element.imageurl[0] || null;
            const urlType = isDynamicURL(imageUrl) ? 'dynamic' : 'static';

            // Construct the card structure
            const card = {
              components: [
                {
                  type: 'HEADER',
                  image_url: imageUrl, // Use the first image URL if available
                  example: null, 
                  format: 'IMAGE',
                  extrainfo: {
                    thumbnail_alignment: element.extrainfo?.thumbnail_alignment || '', // rich card horizontal image alignment 
                    card_orientation: element.extrainfo?.card_orientation || '', // rich card Layout 
                    height: element.extrainfo?.height || '', // vertical rich card media height 
                    media_type: element.extrainfo?.media_type || '', // media type uploaded
                    url_type: urlType, // dynamic or static
                  }
                },
                {
                  type: 'BODY',
                  title: element.title || '', // title of the element
                  subtitle: element.subtitle || '' // subtitle of the element
                },
                {
                  type: 'BUTTONS',
                  buttons: buttons
                }
              ]
            };
            // Add card to carousel
            formattedCarousel.CAROUSEL.cards.push(card);
          });
          if(suggestion_chips.length > 0) {
            formattedCarousel.CAROUSEL.buttons.push(...suggestion_chips);
          }
          // Add the formatted carousel to allElements
          if(formattedCarousel.CAROUSEL.cards.length === 1 && (formattedCarousel.CAROUSEL.cards[0].components[0]?.extrainfo?.card_orientation == 'HORIZONTAL' || formattedCarousel.CAROUSEL.cards[0].components[0]?.extrainfo?.card_orientation == 'VERTICAL')) {
            field = { type: 'richcard', payload: formattedCarousel };
          } else {
            field = { type: 'carousel', payload: formattedCarousel };
          }
          this.carousel_message_json = formattedCarousel;
        }
        if (field) {
          this.allElements.push(field);
        }
      });
    },
    actions() {
      return {
        addText: () => {
          this.allElements.push({ type: 'text', payload: undefined, buttons: [] });
        },
        addImage: () => {
          this.allElements.push({ type: 'image', payload: undefined, attachment_id: undefined });
        },
        addVideo: () => {
          this.allElements.push({ type: 'video', payload: undefined, attachment_id: undefined });
        },
        addDocument: () => {
          this.allElements.push({ type: 'document', payload: undefined, attachment_id: undefined, fileName: undefined, fileExtension: undefined, contentType: undefined });
        },
        addQuickReplies: () => {
          this.allElements.push({ type: 'reply', payload: undefined, buttons: [] });
        },
        addCarouselRcs: () => {
          this.allElements.push({ type: 'carousel', payload: undefined, buttons: [] });
        },
        addRichCardRcs: () => {
          this.allElements.push({ type: 'richcard', payload: undefined, buttons: [] });
        }
      };
    },
    popperSubmit(result) {
      const data = result.new;
      const button = this.allElements[this.editIndex]?.buttons[this.buttonIndex];
      
      if (this.editIndex > -1 && this.buttonIndex > -1 && button) {
        // Set common properties for all button types
        Object.assign(button, {
          text: data.text,
          payload: data.payload,
          postback_action_type: data.postback_action_type,
          postback_action: data.postback_action
        });

        // Handle action-specific properties
        switch(data.action) {
          case 'bot_flow':
          case 'agent_or_group':
          case 'custom':
          case 'opt_in':
          case 'opt_out':
            button.type = 'postback';
            break;
          case 'livechat':
            button.type = 'postback';
            button.payload = '7@1k704um@9';
            break;
          case 'website':
            button.type = 'webview';
            button.url = data.payload;
            button.url_type = data.url_type;
            break;
          case 'app_webview':
            button.type = 'app_webview';
            button.url = data.payload;
            button.url_type = data.url_type;
            button.extrainfo = data.extrainfo;
            break;
          case 'location':
            button.type = 'location';
            button.extrainfo = data.extrainfo;
            break;
          case 'share':
            button.type = 'share';
            break;
          case 'calendar':
            button.type = 'calendar';
            button.extrainfo = data.extrainfo;
            break;
          case 'phone_number':
            button.type = 'phone_number';
            break;
        }
      }
      
      this.addEditModal = undefined;
      this.editIndex = -1;
      this.buttonIndex = -1;
    },
    removeButtonHandler() {
      if (this.buttonIndex == this.editIndex) {
        this.closePopper();
      }

      if (this.editIndex > -1 && this.buttonIndex > -1) {
        this.allElements[this.editIndex].buttons.splice(this.buttonIndex, 1);
      }

      this.addEditModal = undefined;
      this.editIndex = -1;
      this.buttonIndex = -1;
    },
    uploadNewFiles(index) {
      this.uploadfileIndex = index;
    },
    async handleFilesUpload (urlData) {
      try {
        if (this.uploadfileIndex < 0 || this.uploadfileIndex >= this.allElements.length) {
          throw new Error("Invalid upload file index");
        }
        this.filesUploading = true;
        this.allElements[this.uploadfileIndex].payload = urlData[0]?.url;
        if(this.allElements[this.uploadfileIndex].type == 'document' && this.editBroadcast.channel === 'googlercs'){
          this.allElements[this.uploadfileIndex].fileName = urlData[0]?.filename;
          const fileExtension = urlData[0]?.filename.split('.').pop();
          const contentType = this.mimeTypes[fileExtension] || "application/octet-stream"; // Default to binary stream if unknown
          this.allElements[this.uploadfileIndex].fileExtension = fileExtension;
          this.allElements[this.uploadfileIndex].contentType = contentType;
        }
        const messages = {
          document: "File uploaded successfully!",
          video: "Video uploaded successfully!",
          image: "Image uploaded successfully!"
        };
        const fileType = this.allElements[this.uploadfileIndex]?.type;
        if (messages[fileType]) {
          useUIStore().updateToast({
            open: true,
            message: messages[fileType],
            type: "success"
          });
        }
      } catch (error) {
        console.error("Exception: ", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      } finally {
        this.filesUploading = false;
        this.uploadfileIndex = -1;
      }
    },
    handleUrlUpload(uploadedUrl, index) {
      try {
        if (index < 0 || index >= this.allElements.length) {
          throw new Error("Invalid upload file index");
        }
        this.filesUploading = true;
        this.allElements[index].payload = uploadedUrl;
      } catch (error) {
        console.error("Exception: ", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      } finally {
        this.filesUploading = false;
      }
    },
    async copy(item) {
      try {
        navigator.clipboard.writeText(item);
        useUIStore().updateToast({
          open: true,
          message: "Copied to the clipboard!",
          type: "success"
        })
      } catch (error) {
        console.error("Exception: ", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      }
    },
    removeItem(index){
      return this.allElements.splice(index, 1);
    },
    confirmAddCustomField() {
			if(this.customFieldText?.length) {
				this.setTextToCurrentPos("<custom_field_" + this.customFieldText + ">");
				this.customFieldText = undefined;
        this.addCustomFieldIndex = -1;
			} else {
				useUIStore().updateToast({
					open: true,
					message: "Custom Field cannot be empty",
					type: "danger"
				})
			}
		},
    setTextToCurrentPos(text_to_insert) {
			let bodyTextElement = document.getElementById("template_body");
			let curPos = bodyTextElement.selectionStart;
      if(this.insertParamIndex > -1) {
        const elem = this.allElements[this.insertParamIndex];
        let x = elem.payload;
        elem.payload = x && x.length ? (x.slice(0, curPos) + text_to_insert + x.slice(curPos)) : text_to_insert;
      } else if(this.addCustomFieldIndex > -1) {
        const elem = this.allElements[this.addCustomFieldIndex];
        let x = elem.payload;
        elem.payload = x && x.length ? (x.slice(0, curPos) + text_to_insert + x.slice(curPos)) : text_to_insert;
      } else console.info("Nothing to add");
		},
    removeQuickReplyButtonHandler(bIndex, eIndex) {
      if (bIndex == this.editIndex) {
        this.closePopper();
      }
      if (eIndex > -1 && bIndex > -1) {
        this.allElements[eIndex].buttons.splice(bIndex, 1);
      }
      this.addEditModal = undefined;
      this.editIndex = -1;
      this.buttonIndex = -1;
    },
    async getSmsTranscodedMessage(text, editIndex){
      try {
        const trimmedText = text ? text.trim() : '';
        if(trimmedText == '' || trimmedText == undefined){
          return useUIStore().updateToast({ open: true, message: 'Please enter text message before transcoding!', type: "danger" })
        } else {
          this.commonLoader = true;
          let reqBody = {
            text: text
          };
          let smsEncoderResponse = await apiInterceptor.post(environment('VUE_APP_API_URL') + "broadcasts/v1/utilities/sms-encode", reqBody);
          
          // Create a new reference to trigger Vue reactivity
          const updatedElement = { ...this.allElements[editIndex] };
          updatedElement.payload = smsEncoderResponse?.encoded_text;
          this.allElements.splice(editIndex, 1, updatedElement);
          
          // Force update in next tick to ensure RichTextBox re-renders
          await this.$nextTick();
          
          useUIStore().updateToast({
            open: true,
            message: 'Transcoded Message Applied Successfully',
            type: "success"
          });
        }
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong",
          type: "danger"
        })
      } finally {
        this.commonLoader = false;
      }
    },
    setMessageTags(){
      this.simpleMessageTags = messageTags?.allChannelsMessageTags?.filter(({tag}) => ['userfirstname', 'userlastname', 'useremail', 'userphone'].includes(tag));
    },
    openLink(payload) {
      if (payload) {
        window.open(payload, '_blank');
      }
    },
    finalCarouselData(carouselData) {
			this.carousel_message_json = carouselData;
      console.info(this.carousel_message_json);
		},
    resetCarouselData(value){
      if(value){
        this.carousel_message_json = { ...this.carousel_message_json, BODY: { title: "Title", subtitle: "Subtitle" }, CAROUSEL: { cards: [], buttons: [] } };
      }
    },
    transformCarouselData() {
      const { CAROUSEL } = this.carousel_message_json;
      const hasCarouselSuggestionChips = Array.isArray(CAROUSEL?.buttons) && CAROUSEL.buttons.length > 0;

      return [
        {
          message: [""],
          template_type: hasCarouselSuggestionChips ? "quickcarousel" : "carousel",
          template: {
            elements: CAROUSEL.cards.map((card) => {
              const headerComponent = card.components.find((c) => c.type === "HEADER");
              const bodyComponent = card.components.find((c) => c.type === "BODY");
              const buttonsComponent = card.components.find((c) => c.type === "BUTTONS");
              const transformedCard = {
                title: bodyComponent?.title || "",
                subtitle: bodyComponent?.subtitle || "",
                imageurl: headerComponent?.image_url || "",
                buttons: buttonsComponent?.buttons.map((button) => {
                  const type = this.buttonType(button?.type);
                  return {
                    title: button?.text || "",
                    description: button?.text || "",
                    type,
                    payload: button.payload,
                    height_ratio: button.type === "website" ? "full" : undefined,
                    ...(type === "webview" ? { url: button.url, url_type: button.url_type || "" } : {}),
                    ...(type === "app_webview" ? { url: button.url, url_type: button.url_type || "", extrainfo: button.extrainfo } : {}),
                    ...(type !== "app_webview" && ["location", "calendar"].includes(button.type) && button.extrainfo ? { extrainfo: button.extrainfo } : {}),
                    ...(button.postback_action_type && { postback_action_type: button.postback_action_type }),
                    ...(button.postback_action && { postback_action: button.postback_action })
                  };
                }) || [],
                extrainfo: {}
              };
             // Add card_orientation, thumbnail_alignment and height to extrainfo if they exist
              if (headerComponent?.extrainfo?.card_orientation) {
                transformedCard.extrainfo.card_orientation = headerComponent.extrainfo.card_orientation.toUpperCase();
              }
              if (headerComponent?.extrainfo?.thumbnail_alignment) {
                transformedCard.extrainfo.thumbnail_alignment = headerComponent.extrainfo.thumbnail_alignment.toUpperCase();
              }
              if (headerComponent?.extrainfo?.height) {
                transformedCard.extrainfo.height = headerComponent.extrainfo.height.toUpperCase();
              }
              if (headerComponent?.extrainfo.media_type) {
                transformedCard.extrainfo.media_type = headerComponent.extrainfo.media_type.toUpperCase();
              }
              return transformedCard;
            }),
            ...(hasCarouselSuggestionChips && { buttons: CAROUSEL.buttons }),
          },
        },
      ];
    },
    clearAllItems() {
      this.allElements = [];
      this.resetCarouselData(true);
    },
    // Atomically reset to exactly one empty text element. Used by the SMS
    // compliance auto-init so repeated channel switches can't accumulate
    resetToSingleText() {
      this.resetCarouselData(true);
      this.allElements = [{ type: 'text', payload: undefined, buttons: [] }];
    },
    learnMore() {
      window.open('https://developers.google.com/business-communications/rcs-business-messaging/guides/learn/rich-cards#carousels', '_blank');
    },
    getIconForButton(button) {
      return getIcon(button);
    },
    buttonType(type) {
      const typeMap = {
        website: 'webview',
        app_webview: 'app_webview',
        location: 'location',
        share: 'share',
        calendar: 'calendar',
        phone_number: 'phone_number',
        custom: 'postback',
        QUICK_REPLY: 'postback',
      };
      return typeMap[type] || 'postback';
    },
    parseBodyText(text){
			if(text !== undefined){
				// Normalize newlines to prevent extra line breaks
				return text
					.replace(/<br\s*\/?>/gi, '\n')  // Convert <br> tags to newlines
					.replace(/\n{3,}/g, '\n\n')     // Replace 3+ consecutive newlines with 2
					.replace(/^\n+/, '')            // Remove leading newlines
					.replace(/\n+$/, '');           // Remove trailing newlines
			}
			return text;
		}
  }
}
</script>

<style scoped>
.text-buttons {
  position: absolute;
  display: flex;
  height: 100%;
  align-items: center;
  right: 10px;
}
.text-buttons .v-icon {
  cursor: pointer;
  color: var(--purple);
  padding: 5px;
}
.text-buttons .v-icon:hover {
  background-color: rgba(var(--purple), 0.3);
  border-radius: 50%;
}
.text-button-wrapper {
  display: flex;
  width: 100%;
  position: relative;
}
.quick-reply-button-container {
  display: flex;
  column-gap: 10px;
  max-width: 450px;
  overflow-x: scroll;
  padding: 10px 10px;
}

.quick-reply-button-container::-webkit-scrollbar {
  height: 5px;
  width: 5px;
  background-color: #F5F5F5;
}
.quick-reply-buttons-wrapper {
  display: flex;
  column-gap: 10px;
}
.btn-template-dynamic-action {
  cursor: pointer;
  min-width: 120px;
  width: 220px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 16px;
  border: 1px solid var(--purple);
  border-radius: 20px;
  background: transparent;
  color: var(--purple);
  font-size: 14px;
  margin: 0;
  transition: background-color 0.2s;
}

.btn-template-dynamic-action:hover {
  background: var(--purple-opac);
}

.btn-template-dynamic-action.activeReplyButton {
  background: var(--purple);
  color: var(--white);
}

.btn-template-dynamic-action.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.btn-icon-img {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.quick-reply-button-container::-webkit-scrollbar-thumb{
  background-color: var(--purple); 
  background-image: -webkit-linear-gradient(45deg,
    rgba(255, 255, 255, .2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, .2) 50%,
    rgba(255, 255, 255, .2) 75%,
    transparent 75%,
    transparent);
  -webkit-border-radius: 5px;
  border-radius: 5px;
}

.element-container{
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.img-container {
  width: 40%;
  display: block;
  margin: 20px auto 20px auto;
}
.uploaded-container{
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 150px;
  display: block;
  margin: 20px auto 20px auto;
  border-radius: 5px;
}

.model-sections {
  background: var(--white);
  margin: 20px 0px 0px 0px;
  position: relative;
  overflow: visible;
}
.inpt-container {
  width: 360px;
  margin: 0px 30px 10px 46px;
}
.templateInput {
  width: 450px;
  height: auto;
  display: inline-block;
	border-radius: 5px 5px 0px 0px;
  border: 1px solid var(--black);
  border-bottom: none;
  padding: 0px 0px 30px 0px;
}
.templateInputWithoutBttn{
  border-bottom: 1px solid var(--black) !important;
  border-radius: 5px;
}
.replyInput{
  border: 1px solid var(--black) !important;
	border-radius: 5px;
}
.customPaddingBottom{
  padding-bottom: 10px;
}
.img-block{
  border-radius: 5px;
  border: 1px var(--gray-04) solid;
  width: 450px;
  min-height: 110px;
  display: inline-block;
  cursor: pointer;
  background: var(--background-primary);
}
.selectProductSearch{
  margin-bottom: 10px;
  background: var(--background-primary);
  border-radius: 5px;
}
.img-block.no-image{min-height: 200px;}
.delete-field{
  position: absolute;
  top: 0px;
  right: -70px;
}
.rcsCarouselDeleteBttn{
  right: 0px;
  top: 160px;
}
.info-field{
  position: absolute;
  top: 45px;
  right: -70px;
}
.openDocumentIcon{
  color: var(--purple);
  --border-color: var(--purple);
}
.addRow {
  border-radius: 5px;
  border: 1px var(--purple) solid;
  color: var(--purple);
  font-size: 16px;
  font-weight: 600;
  padding: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  width: 100%;
  margin-top: 0px;
}
.addRow:hover {
   border: 2px solid var(--purple);
}
.action-items {
  --background: var(--background-primary);
  border-radius: 5px;
  margin-bottom: 10px;
  cursor: pointer;
  --min-height: 60px;
}
.productImg{
  width: 40px;
  height: 40px;
  border-radius: 5px;
}
.productDesc{
  margin-left: 20px;
  padding: 10px 0px;
}
.productListItems{
  overflow-y: scroll;
  max-height: 62vh;
}
.loaderContainer{
  min-height: 40vh;
  border: 1px solid var(--background-primary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}
.spinner.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0px;
  right: 0px;
  bottom: 0;
}
.cardSpinner{
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 50px 0px;
}
.tooltip_container .tooltip_text.left {
  top: 5%;
  z-index: 999;
}
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.addNew {
  max-width: 450px;
  width: 100%;
}

.addNew.complete {
  border-bottom: 2px #eee dashed;
}
.marginTop{
  margin-top: 10px;
}
.flexContainer{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.paddingLeft{
  padding-left: 10px;
}
.flex-container{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.button-text-container {
  display: flex;
  justify-content: center;
  align-items: center;
	gap: 5px;
}
.buttonMargin{
	flex-grow: 1;
	padding-right: 60px;
}
ion-button.templateAddButton {
	color: var(--purple);
	background: var(--white);
	--border-color: var(--purple);
	--border-radius: 0px 0px 5px 5px;
}
.bttnContainer{
	background: var(--white);
	border: 1px solid var(--purple);
	height: 50px;
	display: flex;
	align-items: center;
}
.bttnContainer:last-child{
	border-radius: 0px 0px 5px 5px;
	padding-bottom: 7px;
	height: 57px;
}
.bttnContainer:not(:last-child) {
  border-bottom: none;
}
.bttnContainer:hover{
	background: var(--purple-opac);
}
.bttnContainer:hover .bttnTitle{
	color: var(--purple);
}
.activeButton{
	background: var(--purple) !important;
}
.activeButton .bttnTitle {
	color: var(--white) !important;
}
.activeReplyButton {
  --background: var(--purple) !important;
}
.closeIcon{
  color: var(--white) !important;
}
.activeReplyButton .replyBttnTitle{
  color: var(--white);
}
.bttnTitle{
  color: var(--purple);
  font-size: 14px;
}
.product-block{
  border-radius: 5px 5px 0px 0px;
  border: 1px var(--gray-04) solid;
  border-bottom: none;
  cursor: pointer;
  background: var(--white);
}
.products-container{
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 200px;
  display: block;
  margin: 20px auto 20px auto;
  border-radius: 5px;
}
.carouselContainer{
  width: 450px;
  display: inline-block;
}
.column-container{
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 20px 20px 0px 20px;
  padding-bottom: 20px;
}
.lastButton{
	padding-bottom: 0px !important;
	height: 50px !important;
}
.custom-upload-container{
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background-primary);
  border-radius: 5px 5px 0px 0px;
}
.info-box{
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  background: var(--purple-opac);
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
}
.info-text{
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  padding-left: 20px;
}
.justify-content{
  justify-content: space-between;
}
.custMrginTop{
  margin-top: 28px;
}
.carousel-section{
  width: 100% !important;
}
.uploadURLContainer{
  width: 92% !important;
}
.custom_mrg_bottom{
  margin-bottom: 10px !important;
}
.rcsRichCardDeleteBttn{
  right: 0px;
  top: 180px;
}
.active_icon{
	color: var(--white) !important;
}
.bodyContainer{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 10px;
  overflow: visible;
  position: relative;
}
@media only screen and (max-width: 760px){
  .model-sections, .element-container {
    width: calc( 100% - 66px ) !important;
  }
  .addNew {
    max-width: 100%;
    margin-left: 0px;
  }
  .img-block{
    width: 95%;
  }
  .inpt-container{
    margin: 0px 10px 10px 10px;
    width: 95%;
  }
  .jinput{
    width: 100%;
  }
  .delete-field{
    right: -65px;
  }
  .carouselContainer{
    width: 95%;
    display: inline-block;
  }

}

/* SMS Compliance Full Width Styles */
.json-builder-sms-compliance .templateInput {
  width: 100% !important;
}

/* Action sheet replacement styles */
.action-sheet-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 400px;
  overflow-y: auto;
}
.action-sheet-item {
  padding: 12px 16px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  color: var(--black);
  transition: background-color 0.15s;
}
.action-sheet-item:hover {
  background-color: var(--purple-opac);
  color: var(--purple);
}
</style>

<style>
.jb-popper-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99998;
  background: transparent;
}
.jb-popper-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
  background: var(--white);
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
  padding: 20px;
  max-height: 80vh;
  overflow-y: auto;
}
</style>